export function normalizeJoinCode(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const code = value.trim().toUpperCase();
  return /^[A-Z0-9]{6}$/.test(code) ? code : null;
}

export function groupJoinPath(code: string): string {
  const normalized = normalizeJoinCode(code);
  if (!normalized) throw new Error('A six-character group code is required.');
  return `/search?join=${normalized}`;
}

export function usesAppleMessages(userAgent: string, maxTouchPoints = 0): boolean {
  return /iPhone|iPad|iPod/.test(userAgent) || (/Macintosh/.test(userAgent) && maxTouchPoints > 1);
}

export function groupInvitation(origin: string, code: string, name: string, appleMessages = false) {
  const base = new URL(origin);
  if (!['https:', 'http:'].includes(base.protocol) || base.username || base.password) {
    throw new Error('An HTTP site origin is required.');
  }
  const url = new URL(groupJoinPath(code), base.origin).href;
  const label = name.replace(/[\r\n\u0000-\u001f]+/g, ' ').trim().slice(0, 60) || 'our group';
  const title = `Join ${label} on the Lost Lands planner`;
  const text = `Join ${label}: ${url}\nCreate an account or sign in, then confirm Join group.`;
  return {
    url, title, text,
    email: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(text)}`,
    sms: `sms:${appleMessages ? '&' : '?'}body=${encodeURIComponent(text)}`,
  };
}

export function discoveryParams(scope: 'groups' | 'people', term: string, setIds: string[]): Record<string, string> {
  return {
    kind: scope === 'groups' ? 'workspace' : 'user',
    q: term.trim(),
    setIds: [...new Set(setIds)].slice(0, 60).join(','),
    sort: 'fresh',
  };
}
